module.exports = __webpack_public_path__ + "img/apoio-gef.9f7fee02.png";